import type { FC } from 'react';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { MedplumProvider } from '@medplum/react';
import { MantineProvider } from '@mantine/core';

import { ToastProvider } from './components/Toast/ToastProvider';
import { queryClient } from './config/queryClient';
import { Router } from './config/router';
import type { router } from './config/router';
import { medplum } from './config/medplum';

import './config/i18n';
import './index.css';

declare module '@tanstack/react-router' {
	// Disabling for tanstack router interface merging
	/* eslint-disable-next-line no-restricted-syntax, @typescript-eslint/consistent-type-definitions */
	interface Register {
		router: typeof router;
	}
}

const App: FC = () => {
	return <Router />;
};

async function bootApp() {
	const rootElement = document.getElementById('root')!;
	if (!rootElement.innerHTML) {
		const root = ReactDOM.createRoot(rootElement);
		root.render(
			<StrictMode>
				<MantineProvider>
					<MedplumProvider medplum={medplum}>
						<ToastProvider>
							<QueryClientProvider client={queryClient}>
								<App />
							</QueryClientProvider>
						</ToastProvider>
					</MedplumProvider>
				</MantineProvider>
			</StrictMode>,
		);
	}
}

bootApp();
